import React from "react";

export let UserContext = React.createContext();

const FromLS = () => {
  return localStorage.getItem("us")
    ? JSON.parse(localStorage.getItem("us"))
    : { token: null, id: null, username: null };
};

const UserProvider = (props) => {
  const [user, setUser] = React.useState(FromLS());
  const [loading, setLoading] = React.useState(false);

  const get_user = (user) => {
    setUser(user);
    localStorage.setItem("us", JSON.stringify(user));
  };

  const [height, setHeight] = React.useState(0);

  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      setHeight(window.pageYOffset);
    });
    return () => window.removeEventListener("scroll", () => {});
  });
  const userLogout = () => {
    setUser({ token: null });
    localStorage.removeItem("us");
  };

  return (
    <UserContext.Provider
      value={{ user, get_user, userLogout, height, loading, setLoading }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export { UserProvider as default };
